import React from 'react';
import { Tooltip, Icon } from 'antd';

const columns = [
  {
    title: '组织名称',
    dataIndex: 'nodeName',
    key: 'nodeName',
    fixed: 'left',
    render: text => {
      if (text.length <= 20) {
        return <span>{text}</span>;
      }
      return (
        <Tooltip placement="top" title={text}>
          <span>{text.substring(0, 20)}...</span>
        </Tooltip>
      );
    },
  },
  {
    title: '所在省',
    dataIndex: 'region',
    key: 'region',
  },
  {
    title: '所在市',
    dataIndex: 'city',
    key: 'city',
  },
  {
    title: '所在区',
    dataIndex: 'area',
    key: 'area',
  },
  {
    title: '局校性质',
    dataIndex: 'orgProperty',
    key: 'orgProperty',
  },
  {
    title: '组织性质',
    dataIndex: 'orgType',
    key: 'orgType',
  },
  {
    title: '学段',
    dataIndex: 'managementEntitySign',
    key: 'managementEntitySign',
  },
  {
    title: (
      <div>
        有效发布文章数&nbsp;
        <Tooltip title="由本组织发布成功，且未删除的文章为有效文章">
          <Icon type="question-circle" />
        </Tooltip>
      </div>
    ),
    dataIndex: 'articleSum',
    key: 'articleSum',
    fixed: 'right',
  },
];
const reporterColumns = [
  {
    title: '组织名称',
    dataIndex: 'nodeName',
    key: 'nodeName',
    fixed: 'left',
    render: text => {
      if (text && text.length <= 20) {
        return <span>{text}</span>;
      }
      return (
        <Tooltip placement="top" title={text}>
          <span>{text.substring(0, 20)}...</span>
        </Tooltip>
      );
    },
  },
  { title: '通讯员', dataIndex: 'publishUserName', key: 'publishUserName' },
  {
    title: '所在省',
    dataIndex: 'region',
    key: 'region',
  },
  {
    title: '所在市',
    dataIndex: 'city',
    key: 'city',
  },
  {
    title: '所在区',
    dataIndex: 'area',
    key: 'area',
  },
  {
    title: '局校性质',
    dataIndex: 'orgProperty',
    key: 'orgProperty',
  },
  {
    title: '组织性质',
    dataIndex: 'orgType',
    key: 'orgType',
  },
  {
    title: '学段',
    dataIndex: 'managementEntitySign',
    key: 'managementEntitySign',
  },
  {
    title: (
      <div>
        有效发布文章数&nbsp;
        <Tooltip title="由本组织发布成功，且未删除的文章为有效文章">
          <Icon type="question-circle" />
        </Tooltip>
      </div>
    ),
    dataIndex: 'articleSum',
    key: 'articleSum',
    fixed: 'right',
  },
];

export { columns, reporterColumns };
